module.exports = __webpack_public_path__ + "static/img/logo-neofect.eea91957.svg";